import cx from 'classnames';
import { Group } from '@visx/group';
import { getTicks, coerceNumber } from '@visx/scale';
import AxisRenderer from "./AxisRenderer.js";
import getTickPosition from "../utils/getTickPosition.js";
import getTickFormatter from "../utils/getTickFormatter.js";
import createPoint from "../utils/createPoint.js";
import Orientation from "../constants/orientation.js";
import getAxisRangePaddingConfig from "../utils/getAxisRangePaddingConfig.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function Axis(_ref) {
  let {
    children = AxisRenderer,
    axisClassName,
    hideAxisLine = false,
    hideTicks = false,
    hideZero = false,
    innerRef,
    left = 0,
    numTicks = 10,
    orientation = Orientation.bottom,
    rangePadding = 0,
    scale,
    tickFormat,
    tickLength = 8,
    tickValues,
    top = 0,
    ...restProps
  } = _ref;
  const format = tickFormat ?? getTickFormatter(scale);
  const isLeft = orientation === Orientation.left;
  const isTop = orientation === Orientation.top;
  const horizontal = isTop || orientation === Orientation.bottom;
  const tickPosition = getTickPosition(scale);
  const tickSign = isLeft || isTop ? -1 : 1;
  const range = scale.range();
  const rangePaddingConfig = getAxisRangePaddingConfig(rangePadding);
  const axisFromPoint = createPoint({
    x: Number(range[0]) + 0.5 - rangePaddingConfig.start,
    y: 0
  }, horizontal);
  const axisToPoint = createPoint({
    x: Number(range[range.length - 1]) + 0.5 + rangePaddingConfig.end,
    y: 0
  }, horizontal);
  const filteredTickValues = (tickValues ?? getTicks(scale, numTicks)).filter(value => !hideZero || value !== 0 && value !== '0').map((value, index) => ({
    value,
    index
  }));
  const ticks = filteredTickValues.map(_ref2 => {
    let {
      value,
      index
    } = _ref2;
    const scaledValue = coerceNumber(tickPosition(value));
    return {
      value,
      index,
      from: createPoint({
        x: scaledValue,
        y: 0
      }, horizontal),
      to: createPoint({
        x: scaledValue,
        y: tickLength * tickSign
      }, horizontal),
      formattedValue: format(value, index, filteredTickValues)
    };
  });
  return /*#__PURE__*/_jsx(Group, {
    className: cx('visx-axis', axisClassName),
    innerRef: innerRef,
    top: top,
    left: left,
    children: children({
      ...restProps,
      axisFromPoint,
      axisToPoint,
      hideAxisLine,
      hideTicks,
      hideZero,
      horizontal,
      numTicks,
      orientation,
      rangePadding,
      scale,
      tickFormat: format,
      tickLength,
      tickPosition,
      tickSign,
      ticks
    })
  });
}